/* tslint:disable */
/* eslint-disable */
/* @relayHash 3048fc75cf8d667ca09bcf3fcf89c768 */

import { ConcreteRequest } from "relay-runtime";
export type DeleteWorksheetInput = {
    id: string;
    clientMutationId?: string | null;
};
export type DeleteWorksheetMutationVariables = {
    input: DeleteWorksheetInput;
};
export type DeleteWorksheetMutationResponse = {
    readonly deleteWorksheet: {
        readonly id: string;
    } | null;
};
export type DeleteWorksheetMutation = {
    readonly response: DeleteWorksheetMutationResponse;
    readonly variables: DeleteWorksheetMutationVariables;
};



/*
mutation DeleteWorksheetMutation(
  $input: DeleteWorksheetInput!
) {
  deleteWorksheet(input: $input) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteWorksheetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteWorksheet",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteWorksheetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteWorksheetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteWorksheetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteWorksheetMutation",
    "id": null,
    "text": "mutation DeleteWorksheetMutation(\n  $input: DeleteWorksheetInput!\n) {\n  deleteWorksheet(input: $input) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2262459bc4ece751805649dd7f56ac38';
export default node;
